module.exports = __webpack_public_path__ + "static/activity-page-cf1f7d99dcdbd6a38f5341c2ecb6802a.png";